function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.84877 6.03658C1.39665 6.28891 1.2347 6.85998 1.48703 7.3121C1.73937 7.76422 2.31044 7.92617 2.76256 7.67384L1.84877 6.03658ZM2.76256 7.67384L11.106 3.01724L10.1922 1.37998L1.84877 6.03658L2.76256 7.67384Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.3259 12.2379C7.07357 12.69 7.23552 13.2611 7.68764 13.5134C8.13976 13.7657 8.71083 13.6038 8.96316 13.1517L7.3259 12.2379ZM8.96316 13.1517L13.6198 4.80827L11.9825 3.89449L7.3259 12.2379L8.96316 13.1517Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1131 0.337087C9.74699 -0.0290291 9.1534 -0.0290291 8.78728 0.337087C8.42117 0.703204 8.42117 1.2968 8.78728 1.66291L10.1131 0.337087ZM13.3373 6.21291C13.7034 6.57903 14.297 6.57903 14.6631 6.21291C15.0292 5.8468 15.0292 5.2532 14.6631 4.88709L13.3373 6.21291ZM8.78728 1.66291L13.3373 6.21291L14.6631 4.88709L10.1131 0.337087L8.78728 1.66291Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.88791 10.4379L6.55082 9.77502L5.225 8.4492L4.56209 9.11211L5.88791 10.4379ZM0.337087 13.3371C-0.0290291 13.7032 -0.0290291 14.2968 0.337087 14.6629C0.703204 15.0291 1.2968 15.0291 1.66291 14.6629L0.337087 13.3371ZM4.56209 9.11211L0.337087 13.3371L1.66291 14.6629L5.88791 10.4379L4.56209 9.11211Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.66291 4.88708C1.2968 4.52096 0.703204 4.52096 0.337087 4.88708C-0.0290291 5.25319 -0.0290291 5.84678 0.337087 6.2129L1.66291 4.88708ZM8.78709 14.6629C9.1532 15.029 9.7468 15.029 10.1129 14.6629C10.479 14.2968 10.479 13.7032 10.1129 13.3371L8.78709 14.6629ZM0.337087 6.2129L8.78709 14.6629L10.1129 13.3371L1.66291 4.88708L0.337087 6.2129Z",
  fill: "currentColor"
});

function SvgPinnIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnIcon2);
export default __webpack_public_path__ + "static/media/pinn-icon-2.45d3a0b8.svg";
export { ForwardRef as ReactComponent };